import { render, staticRenderFns } from "./FormMemberReferral.vue?vue&type=template&id=8416a95e"
import script from "./FormMemberReferral.vue?vue&type=script&lang=js"
export * from "./FormMemberReferral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports